import React, { useState } from 'react';
import classNames from 'classnames';
import {
  CircularProgress,
  withStyles,
  Button,
  withWidth,
} from '@material-ui/core';
import Logo from '../../../assets/real-sign.svg';
import ZoomIn from '../../../assets/zoomIn.svg';
import {
  EDITOR_MODE,
  ZOOM_DECREASE_DEFAULT,
  ZOOM_INCREASE_DEFAULT,
  ZOOM_MAXIMUM,
  ZOOM_MINIMUM,
} from '../../constants';
import { compose, noop } from '../../../utility';
import ZoomOut from '../../../assets/zoomOut.svg';
import Download from '../../../assets/download.svg';
import Merge from '../../../assets/merge.svg';
import styles from './viewToolbar.styles';

const ViewToolbar = ({
  classes,
  zoom,
  zoomAdjustmentFactor,
  handleUpdateZoom,
  downloadDocuments,
  currentlyDownloading,
  mode,
  width,
  files,
}) => {
  const [zipDownload, setZipDownload] = useState(false);
  const [mergeDownload, setMergeDownload] = useState(false);
  const canZoomIn =
    zoom + ZOOM_INCREASE_DEFAULT * zoomAdjustmentFactor <=
    ZOOM_MAXIMUM * zoomAdjustmentFactor;
  const canZoomOut =
    zoom + ZOOM_DECREASE_DEFAULT * zoomAdjustmentFactor >=
    ZOOM_MINIMUM * zoomAdjustmentFactor;

  const multiple = files > 1;

  const handleDownload = (merge: boolean = false) => {
    setMergeDownload(false);
    setZipDownload(false);

    const callBack = merge ? setZipDownload : setMergeDownload;
    downloadDocuments(merge, callBack);
  };

  return (
    <div
      className={classes.root}
      style={{
        position:
          mode === EDITOR_MODE.INSTANCE_VIEW || mode === EDITOR_MODE.SIGNING
            ? 'fixed'
            : 'static',
      }}
    >
      <Logo className={classes.logo} />
      <div className={classes.zoomIcons}>
        <ZoomIn
          data-testid="zoom-in"
          className={classNames(classes.zoomIcon, {
            [classes.zoomIconDisabled]: !canZoomIn,
          })}
          onClick={canZoomIn ? handleUpdateZoom(ZOOM_INCREASE_DEFAULT) : noop}
        />
        <ZoomOut
          data-testid="zoom-out"
          className={classNames(classes.zoomIcon, {
            [classes.zoomIconDisabled]: !canZoomOut,
          })}
          onClick={canZoomOut ? handleUpdateZoom(ZOOM_DECREASE_DEFAULT) : noop}
        />
      </div>
      <Button
        onClick={() => handleDownload()}
        style={{ opacity: zipDownload && currentlyDownloading ? 0 : 1 }}
      >
        <span className={classes.downloadIcon}>
          {!currentlyDownloading ? (
            <Download />
          ) : (
            <CircularProgress
              variant="indeterminate"
              value={100}
              size={20}
              thickness={2}
              className={classes.loader}
            />
          )}
        </span>
        {!['xs', 'sm'].includes(width) && (
          <span>
            Download
            {multiple && ' Zip'}
          </span>
        )}
      </Button>
      {multiple && (
        <Button
          onClick={() => handleDownload(true)}
          style={{ opacity: mergeDownload && currentlyDownloading ? 0 : 1 }}
        >
          <span className={classes.downloadIcon}>
            {!currentlyDownloading ? (
              <Merge />
            ) : (
              <CircularProgress
                variant="indeterminate"
                value={100}
                size={20}
                thickness={2}
                className={classes.loader}
              />
            )}
          </span>
          {!['xs', 'sm'].includes(width) && <span>DOWNLOAD MERGED PDF</span>}
        </Button>
      )}
    </div>
  );
};

export default compose(withStyles(styles), withWidth())(ViewToolbar);
